<template>
  <v-card outlined tile>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-center title"> Flags </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><v-autocomplete v-model="applyFlags" label="Add Flags" multiple :items="flagTypes" item-text="name" item-value="uuid" :loading="savingFlags" :disabled="savingFlags">
              <template v-slot:append-outer>
                <v-btn @click="submitFlags" class="success" icon :loading="savingFlags" :disabled="savingFlags"><v-icon>mdi-arrow-right</v-icon></v-btn>
              </template>
            </v-autocomplete></td>
          </tr>
          <tr>
            <td>
              <v-chip v-for="flag in sample.sample_flags" :key="flag.uuid" :color="flag.flag_type.color" class="white--text">
                {{flag.flag_type.name}}
                <v-btn class="ml-2" @click="deleteFlag(flag)" icon x-small outlined dark><v-icon small>close</v-icon></v-btn>
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-divider></v-divider>
      <v-form ref="form">
        <v-simple-table>
          <thead>
          <tr><th colspan="3" class="text-center title">Notes</th></tr>
          <tr>
            <th>When</th>
            <th>Updated by</th>
            <th>Type</th>
            <th>Note</th>
            <th>Edit</th>
          </tr>
          </thead>
          <tbody>
          <!--          <v-form refs="form">-->
          <tr>
            <td>----</td>
            <td>{{this.$store.getters.name}}</td>
            <td>
              <v-autocomplete
                  v-model="form.sample_note_type_uuid"
                  label="Note Type"
                  :items="$store.$db().model('sampleNoteTypes').all()"
                  item-text="name"
                  item-value="uuid"
                  :rules="[v => !!v || 'This field is required.']"
                  solo-inverted
                  dense
                  mandatory :loading="savingNote" :disabled="savingNote"
              ></v-autocomplete>
            </td>
            <td>
              <v-text-field v-model="form.note" label="Note" :rules="[v => !!v || 'This field is required.']" solo-inverted dense :loading="savingNote" :disabled="savingNote"></v-text-field>
            </td>
            <td class="pb-5">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" @click="submitNote" class="success white--text" icon small :loading="savingNote" :disabled="savingNote"><v-icon>mdi-arrow-right</v-icon></v-btn>
                </template>
                <span>Submit Note</span>
              </v-tooltip>
            </td>
          </tr>
          <!--          </v-form>-->
          <tr v-for="note in sample.sample_notes" :key="note.uuid">
            <td>{{$moment.utc(note.created_at).local().fromNow()}}</td>
            <td>{{ user(note) }}</td>
            <td>{{ note.note_type.name }}</td>
            <td>{{ note.note }}</td>
            <td>
              <SampleEditNote :note="note"></SampleEditNote>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SampleNotes",
  components: {
    SampleEditNote: () => import("@/views/orders/components/SampleEditNote")
  },
  data: () => ({
    show: false,
    savingNote: false,
    savingFlags: false,
    applyFlags: [],
    form: {
      uuid: null,
      note: null,
      sample_note_type_uuid: null,
      sample_uuid: null,
    }
  }),
  props:{
    sample: {
      required: true,
    }
  },
  computed: {
    flagTypes(){
      let filtered = this.$store.state.filtered_flags || this.$store.state.manifest_filtered_flags || [];
      return this.$store.$db().model('sampleFlagTypes').query().where((flag) => {
        if (filtered.includes(flag.uuid)) return false;
        return !this.sample.sample_flags.find(sampleFlag => flag.uuid === sampleFlag.sample_flag_type_uuid);
      }).get();
    }
  },
  methods: {
    user(note){
      let user = this.$store.$db().model('users').find(note.updated_by ? note.updated_by : note.created_by);
      if(user){
        return user.name
      }
      return 'unknown'
    },
    async submitNote(){
      if(!this.$refs.form.validate()) return;
      try{
        this.savingNote = true;
        this.form.sample_uuid = this.sample.uuid;
        this.form.created_by = this.$store.getters.id;
        this.form.updated_by = this.$store.getters.id;
        await this.$store.$db().model('sampleNotes').api().save(this.form);
        this.$refs.form.reset();
      }catch(e){
        this.$store.dispatch("showError", "Failed to submit note")
      }finally{
        this.savingNote = false;
      }
    },
    async deleteFlag(flag){
      await this.$store.$db().model('sampleFlags').api().destroy(flag.uuid, "Delete flag: "+flag.flag_type.name)
    },
    async submitFlags(){
      this.savingFlags = true;
      let flags = this.applyFlags.filter(flag => !this.sample.sample_flags.some(sampleFlag => sampleFlag.sample_flag_type_uuid === flag));
      flags = flags.map((flag) => {
        return {
          uuid: null,
          sample_flag_type_uuid: flag,
          sample_uuid: this.sample.uuid,
          created_by: this.$store.getters.id,
        }
      });
      try{
        this.savingFlags = true;
        await this.$store.$db().model('sampleFlags').api().save({
          collection: flags
        });
      }catch(e){
        this.$store.dispatch("showError", "Failed to save flags");
      }finally{
        this.savingFlags = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
